/** @internalapi @module vanilla */ /** */
export * from './vanilla/index';
//# sourceMappingURL=vanilla.js.map


// WEBPACK FOOTER //
// ./node_modules/@uirouter/core/lib-esm/vanilla.js